import GenericTemplate from "../Common/GenericTemplate";

// the sub-path and sub-components mapping are in src/Config/routes.js
const Report = () => {
  const menuItems = [
    { label: "Report", icon: "pi pi-chart-bar", path: "report" },
  ];

  return <GenericTemplate menuItems={menuItems} />;
};

export default Report;